import axios from 'axios'
import appconst from './appconst'
import Vue from 'vue'
import nprogress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' //样式必须引入
const CryptoJS = require('crypto-js'); //引入加密模块
import signMd5Utils from './signMd5Utils'
import {decryptData ,ENC_KEY,ENC_IV,isTextEndsWithWhiteList,security_EncriptResponse,security_EncriptRequest,security_VerifyGET,security_WhiteListUrl} from '../utils/encData/index.js';




/* let security_EncriptResponse = true;//开启对后端返回的reponse的解密
let security_EncriptRequest = true;//开启 POST 类型的request body 加密 
let security_VerifyGET = true;//开启GET类型的ajax请求的querystring的签名验签
// let security_WhiteListUrl = ['/AbpUserConfiguration/GetAll','/api/TokenAuth/Authenticate','/api/services/app/Session/GetCurrentLoginInformations']; //白名单
let security_WhiteListUrl = []; //白名单

let isDev = false //process.env.NODE_ENV === 'development';
if (isDev) {
    console.log('开发环境');
    security_EncriptResponse = false;
    security_EncriptRequest = false;
    security_VerifyGET = false;
} else if (process.env.NODE_ENV === 'production') {
    console.log('生产环境');
    // isDev = false;
    security_EncriptResponse = true;
    security_EncriptRequest = true;
    security_VerifyGET = true;
}
//判断白名单存在
function isTextEndsWithWhiteList(text: string): boolean {
    if (!Array.isArray(security_WhiteListUrl) || security_WhiteListUrl.length === 0) {
        return false;
    }
    for (const url of security_WhiteListUrl) {
        if (text.endsWith(url)) {
            return true;
        }
    }
    return false;
} 
// 解码
function decryptData(data) {
    let encryptedData = data;
    console.log(CryptoJS);
    let key = CryptoJS.enc.Utf8.parse('krpd34i1');
    let iv = CryptoJS.enc.Utf8.parse('r3fb8eot');
    let decrypted = CryptoJS.DES.decrypt(
        encryptedData,
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    data = decrypted.toString(CryptoJS.enc.Utf8);
    data = JSON.parse(data);
    return data;
}
*/
const ajax = axios.create({
    baseURL: appconst.remoteServiceBaseUrl,
    timeout: 30000,

});
let timer = null
ajax.interceptors.request.use(function (config) {
    console.log("🚀 ~ config:", config)
    if (!!window.abp.auth.getToken()) {
        config.headers.common["Authorization"] = "Bearer " + window.abp.auth.getToken();
    }

    config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();

    let method = config.method.toUpperCase();
    // post加密
    if (security_EncriptRequest && isTextEndsWithWhiteList(config.url) && method == "POST") {
        //加密reqeust
        config.headers.common["Abp.B"] = "";
        let data = CryptoJS.DES.encrypt(JSON.stringify(config.data), CryptoJS.enc.Utf8.parse(ENC_KEY), {
            iv: CryptoJS.enc.Utf8.parse(ENC_IV),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString();

        config.data = { data: data };
        console.log("request body加密后：", config.data);

    }
    else if (security_VerifyGET &&isTextEndsWithWhiteList(config.url) && method == "GET") {
        if (!config.params) {
            config.params = {};
        }
        let timestamp = signMd5Utils.getDateTimeToString()
        let paramsString = JSON.stringify(config.params);
        let sign = signMd5Utils.getSign(paramsString, timestamp)
        paramsString = encodeURIComponent(paramsString)
        //将签名和时间戳，添加在请求接口 Header
        config.headers.common['X-Sign'] = sign;
        config.headers.common['X-TIMESTAMP'] = timestamp;
        config.headers.common['X-P'] = paramsString;
        console.log("md5:", sign);
        console.log("timestamp:", timestamp);
        console.log("paramsString:", paramsString);
    }

    nprogress.start()
    return config;
}, function (error) {
    nprogress.done()

    return Promise.reject(error);
});
let vm = new Vue({});
ajax.interceptors.response.use((respon) => {
    if (security_EncriptResponse) {
        respon.data = decryptData(respon.data.data);
        console.log(respon.data);
    }

    nprogress.done()
    return respon
}, (error) => {
   if (security_EncriptResponse && error.response.data.data) {
        error.response.data = decryptData(error.response.data.data);

    }
    
    nprogress.done()
    //这个定时器为了解决弹框一闪而过的bug
    clearTimeout(timer)

    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
        timer = setTimeout(() => {
            vm.$Modal.error({ title: error.response.data.error.message, content: error.response.data.error.details })
        }, 200);
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
        timer = setTimeout(() => {
            vm.$Modal.error({
                title: '错误',
                content: error.response.data.error.message,
            });
        }, 200);
        if (error.response.data.unAuthorizedRequest) {
            location.reload();
        }
    } else if (!error.response) {
        timer = setTimeout(() => {
            vm.$Modal.error(window.abp.localization.localize('UnknownError'));
        }, 200);
    }
    setTimeout(() => {
        vm.$Message.destroy();
    }, 2000);
    return Promise.reject(error);
})
export default ajax;